import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type userRegionStateType = {
  isGetPositionPermissionAllowed?: boolean;
  isGetRegionRequestSuccess?: boolean;
  userLatitude?: string;
  userLongitude?: string;
  userRegion?: string;
  userRegionDepth1?: string;
  userRegionDepth2?: string;
  userRegionDepth3?: string;
};

const initialState: userRegionStateType = {
  isGetPositionPermissionAllowed: undefined,
  isGetRegionRequestSuccess: undefined,
  userLatitude: undefined,
  userLongitude: undefined,
  userRegion: undefined,
  userRegionDepth1: undefined,
  userRegionDepth2: undefined,
  userRegionDepth3: undefined,
};

export const userRegionSlice = createSlice({
  name: 'userRegion',
  initialState,
  reducers: {
    setIsGetPositionPermissonAllowed: (state, action: PayloadAction<boolean>) => {
      state.isGetPositionPermissionAllowed = action.payload;
    },

    setIsGetRegionRequestSuccess: (state, action: PayloadAction<boolean>) => {
      state.isGetRegionRequestSuccess = action.payload;
    },

    setUserLatitude: (state, action: PayloadAction<string>) => {
      state.userLatitude = action.payload;
    },

    setUserLongitude: (state, action: PayloadAction<string>) => {
      state.userLongitude = action.payload;
    },

    setUserRegion: (state, action: PayloadAction<string>) => {
      state.userRegion = action.payload;
    },

    setUserRegionDepth1: (state, action: PayloadAction<string>) => {
      state.userRegionDepth1 = action.payload;
    },

    setUserRegionDepth2: (state, action: PayloadAction<string>) => {
      state.userRegionDepth2 = action.payload;
    },

    setUserRegionDepth3: (state, action: PayloadAction<string>) => {
      state.userRegionDepth3 = action.payload;
    },
  },
});
